$(() => {
  // margin-top-for-slider-title
  $(window).on("load", () => {
    marginTop();
  });
  const marginTop = () => {
    $.each($(".bs-section--industry-careers-members"), (index, element) => {
      const $this = $(element),
        titleHeight = $this.find(".bs-div--title-wrapper").outerHeight() + 74;
      $.each($this.find(".bs-div--content-wrapper"), (index, ele) => {
        if ($(window).width() >= 768) {
          $(ele).css("margin-top", titleHeight + "px");
        } else {
          $(ele).removeAttr("style");
        }
      });
    });
  };
  marginTop();
});
